// extracted by mini-css-extract-plugin
export default {"fullWidth":"Dn-z","image":"En-z","lazyLoadPicture":"Fn-z","lazyLoadSpinner":"Gn-z","lazyLoadSpin":"Hn-z","lazyLoadImage":"In-z","hasStyledAspectRatio":"Jn-z"};